import { excludeUndefined } from "./array.util";

export const encodeKeyValuePair = (key: string, value: string | number) =>
    `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;

export function encodeSearchQuery(query: object) {
    return Object.entries(query)
        .map(([key, value]) => (value ? encodeKeyValuePair(key, value) : undefined))
        .filter(excludeUndefined)
        .join("&");
}

export function decodeSearchQuery(query: string) {
    return Object.fromEntries(new URLSearchParams(query));
}
